export default "__VITE_ASSET__CwfT04NH__"